import { useState } from 'react'
import { Link, Typography } from '@material-ui/core'
import { OpenInNewWindowIcon } from 'components/icons'
import Button from 'baby-ui/foundation/Button'
import useStyles from './InsuranceVerificationFailed.styles'
import InsuranceForm, {
  InsuranceFormSuccessCallback,
} from '../../../forms/InsuranceForm/InsuranceForm'
import { BackIcon } from '../../../icons/BackIcon'
import {
  HEALTH_CONTACT_EMAIL,
  PUMP_PARTS_STORE_PAGE_URL,
} from '../../../constants'

interface InsuranceVerificationFailedV2Props {
  customerId: APIResponse.Customer['id']
  onSuccess: InsuranceFormSuccessCallback
  error: APIResponse.DME.SubscriptionErrorType
}

const InsuranceVerificationFailedV2 = (
  props: InsuranceVerificationFailedV2Props
) => {
  const { error } = props
  const classes = useStyles()
  const [insuranceFormVisible, setInsuranceFormVisible] = useState(false)

  if (insuranceFormVisible) {
    return (
      <>
        <Button
          color="primary"
          startIcon={<BackIcon />}
          style={{ textDecoration: 'underline' }}
          variant="text"
          onClick={() => {
            setInsuranceFormVisible(false)
          }}
        >
          Back
        </Button>
        <InsuranceForm {...props} />
      </>
    )
  }

  return (
    <>
      <Typography
        className={classes.title}
        color="primary"
        component="h1"
        variant="h4"
      >
        {error === 'INSURANCE_VERIFICATION_FAILED_INACTIVE'
          ? 'The insurance plan we have on file is no longer active.'
          : 'Something went wrong when we tried verifying your insurance.'}
      </Typography>
      <Typography
        className={classes.body}
        color="textSecondary"
        variant="body2"
      >
        {error === 'INSURANCE_VERIFICATION_FAILED_INACTIVE'
          ? "If you've changed insurance, you can update it below and use it for your order."
          : "We'll need to get up-to-date insurance information for your order."}
      </Typography>
      <Button
        fullWidth
        color="secondary"
        size="large"
        type="button"
        variant="contained"
        onClick={() => {
          setInsuranceFormVisible(true)
        }}
      >
        {error === 'INSURANCE_VERIFICATION_FAILED_INACTIVE'
          ? 'I Have New Insurance'
          : 'Update Insurance'}
      </Button>

      <ShopForPartsCTA />
      <HelpCTA />
    </>
  )
}

const ShopForPartsCTA = () => {
  const classes = useStyles()

  return (
    <>
      <Typography
        className={classes.subtitle}
        color="primary"
        component="h1"
        variant="h4"
      >
        Need parts now?
      </Typography>
      <Typography
        className={classes.body}
        color="textSecondary"
        variant="body2"
      >
        We should have what you need on the Babylist Shop.
      </Typography>

      <Button
        color="primary"
        endIcon={<OpenInNewWindowIcon />}
        href={PUMP_PARTS_STORE_PAGE_URL}
        size="large"
        style={{ textDecoration: 'underline', paddingLeft: 0 }}
        variant="text"
      >
        Shop for Pump Parts
      </Button>
    </>
  )
}

const HelpCTA = () => {
  const classes = useStyles()

  return (
    <>
      <Typography
        className={classes.subtitle}
        color="primary"
        component="h1"
        variant="h4"
      >
        We're here to help.
      </Typography>
      <Typography
        className={classes.body}
        color="textSecondary"
        variant="body2"
      >
        Still have questions or think there's been an error? Email{' '}
        <Link
          className={classes.emailLink}
          href={`mailto:${HEALTH_CONTACT_EMAIL}`}
        >
          {HEALTH_CONTACT_EMAIL}
        </Link>
        .
      </Typography>
    </>
  )
}

export default InsuranceVerificationFailedV2
